import React from "react";
import { any, async, fromJSX, nothing, Updater, Widget } from "widgets-for-react";
import { EducationFormLayout } from "./educationFormLayout";
import { EducationFormState, EducationFormStateUpdaters } from "./educationFormState";
import { PostMessage } from "../iframe/iframe.state";
import { ConfirmationMessage, RegistrationType, ScrollToTopMessage, SubmissionMessage } from "./educationFormUtils";
import { ecommerceGA4, EcommerceItem } from "../../utils/datalayer";
import { EventTemplate } from "../models/Events/Events";
import { CoursePage } from "../cmsPage/cmsPageState";

export const educationFormWidget = (
  params: { eventId: string },
  state: EducationFormState
): Widget<Updater<EducationFormState>> => {
  const { pageData, eventData } = state
  return any<Updater<EducationFormState>>([
    async<CoursePage>(pageData).map(EducationFormStateUpdaters.updatePageData),
    async<EventTemplate>(eventData).map(EducationFormStateUpdaters.updateEventData),
    eventData.kind == "loaded" && pageData.kind == "loaded" ?
      fromJSX((setState) => (
        <EducationFormLayout 
          {...params} 
          embedCode={""} 
          eventData={eventData.value}
          pageData={pageData.value}
          handlePostMessage={(m: PostMessage) => handlePostMessage(m, state, setState)} 
        />
      ))
    : nothing()
  ])
}

const handlePostMessage = (m: PostMessage, state: EducationFormState, setState: (_: Updater<EducationFormState>) => void) => {
  if (m.type == "submission") {
    // Save submission data
    setState((s0) => ({...s0, submissionData: m as SubmissionMessage}))
  } else if (m.type == "confirmation") {
    const message = m as ConfirmationMessage
    // Verify sent confirmation relates to submission data
    if (state.submissionData && message.session_id == state.submissionData.session_id && message.is_confirmed)
    // Send saved submission data
    sendSubmissionToGA(state.submissionData)
  } else if (m.type == "scrollToTop") {
    const message = m as ScrollToTopMessage
    document.getElementById('iframe')?.scrollIntoView({ behavior: "smooth" });
  }
   else {
    console.warn(`No handler created for postMessage event: ${m.type}`)
  }
}

const sendSubmissionToGA = (data: SubmissionMessage) => {
  const priceExcl = parseFloat(data.price_exl_vat.replace(/[^\d.-]/g, ''));
  const priceIncl = parseFloat(data.price_inc_vat.replace(/[^\d.-]/g, ''));
  const transactionId  = `n${data.eventTemplate_id}-${Math.floor(new Date().getTime() / 1000)}`
  const item: EcommerceItem = {
    item_name: data.eventTemplate_name,
    item_id: data.eventTemplate_id,
    price: priceExcl,
    item_brand: 'unknown',
    item_category: RegistrationType[data.registration_type],
    item_category2: data.eventTemplate_name,
    quantity: data.participantsCount
  }

  ecommerceGA4(priceIncl, transactionId, [item])
}
